export * from './DeleteQuizConfirmation';
export { useDeleteQuizConfirmation } from './UseDeleteQuizConfirmation';
